/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable quotes */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
} from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { HiDownload, HiOutlineUserGroup } from 'react-icons/hi';
import { AiOutlineFile } from 'react-icons/ai';
import { MdFilterList, MdSearch } from 'react-icons/md';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';
import * as Yup from 'yup';
import { isValidCpf } from '../../utils/isValidCpf';
import InputOutlined from '../../components/InputOutLined';
import Checkbox from '../../components/Checkbox';
import Select from '../../components/Select';
import { useToast } from '../../hooks/toast';
import Input from '../../components/Input';
import Button from '../../components/Button';
import FileInput from '../../components/FileInput';
import CardOrdersTable from './Components/CardOrdersTable';
import TableLoader from '../../components/TableLoader';
import FiltersModal from './Components/FiltersModal';
import {
  EmployeeResponse,
  Employee,
  ArrayFilters,
} from '../../interfaces/employee';
import EmployeeService from '../../services/employee';
import DepartamentosService from '../../services/departamentos';
import LoaderModal from '../../components/LoaderModal';

import DownLoadFile from '../../utils/DownLoadFile';
import getValidationErrors from '../../utils/getValidationErrors';
import { Row, Column, IconContainer } from '../../styles/components';
import Modal from '../../components/Modal';
import MainLoader from '../../components/MainLoader';
import AuthService from '../../services/auth';

import {
  Container,
  Title,
  ButtonsContainer,
  StatusRow,
  FiltersContainer,
  CardSection,
  Acoes,
  FlexRow,
  LinkModal,
  FormWrapper,
  ModalContent,
} from './styles';

interface EditParams {
  id: string;
}

const Funcionarios: React.FC = () => {
  const services = { EmployeeService: new EmployeeService() };
  const depservice = { DepartamentosService: new DepartamentosService() };
  const authService = { AuthService: new AuthService() };
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const formRefAssociar = useRef<FormHandles>(null);
  const formRefExcluir = useRef<FormHandles>(null);
  const formRefAtivar = useRef<FormHandles>(null);
  const formRefTxt = useRef<FormHandles>(null);
  const formRefRelatorio = useRef<FormHandles>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalAssociar, setModalAssociar] = useState<boolean>(false);
  const [modalImportar, setModalImportar] = useState<boolean>(false);
  const [modalImportarTxt, setModalImportarTxt] = useState<boolean>(false);
  const [modalAssociarTable, setModalAssociarTable] = useState<boolean>(false);
  const [modalExcluir, setModalExcluir] = useState<boolean>(false);
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const [modalAtivar, setModalAtivar] = useState<boolean>(false);
  const [importLoading, setImportLoading] = useState<boolean>(false);
  const [associarField, setAssociarField] = useState<any>();
  const [statusChecked, setStatusChecked] = useState<boolean>();
  const [excluirCodigo, setExcluirCodigo] = useState<string>('');
  const [excluirNome, setExcluirNome] = useState();
  const [ativarNome, setAtivarNome] = useState();
  const [ativarMatricula, setAtivarMatricula] = useState();
  const [statusNome, setStatusNome] = useState();
  const [funcionarioCPF, setFuncionarioCPF] = useState();
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [statusCodigo, setStatusCodigo] = useState<string>('');
  const [departamentos, setDepartamentos] = useState<any>([]);
  const { push } = useHistory();
  const [errors, setErrors] = useState<any>([]);
  const [employees, setEmployees] = useState<EmployeeResponse>(
    {} as EmployeeResponse,
  );
  const [titular, setTitular] = useState<any>();
  const [tipoRelatorio, setTipoRelatorio] = useState<string>('');
  const [employeesCPF, setEmployeesCPF] = useState<Employee>({} as Employee);
  const [statusRel, setStatusRel] = useState<ArrayFilters>();
  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });
  console.log({ employeesCPF });
  const { id } = useParams<EditParams>();
  console.log({ id });
  const schema = Yup.object().shape({
    ArquivoImportacao: Yup.string().required('É necessário informar o arquivo'),
  });

  const schemaRelatorio = Yup.object().shape({
    email: Yup.string().required('É necessário informar o email'),
  });
  const getEmployeesList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await services.EmployeeService.getEmployee(filters);
      setEmployees(response.data);
      setTotalRows(response.data.FuncionarioListaTotal);
      setLoading(false);
      console.log(response.data);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    getEmployeesList();
  }, [page, perPage, filters]);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleGetDepartamentos = useCallback(async () => {
    try {
      const response = await depservice.DepartamentosService.getDepartamentos();
      setDepartamentos(response.data.DepartamentoLista);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  useEffect(() => {
    handleGetDepartamentos();
    getTitular();
    localStorage.removeItem('@TransfacilPJ:DepartmentFilter');
  }, []);

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  const handleApplyFilter = useCallback((filtersOptions: any) => {
    setFilters({
      filters: [
        ...filters.filters,
        filtersOptions.departamento && {
          'code-departament': filtersOptions.departamento,
        },
        filtersOptions.status && { status: filtersOptions.status },
      ],
    });
    setStatusRel(filtersOptions.status);
    setShowModal(false);
  }, []);

  const handleClearFilters = useCallback(() => {
    formRef.current?.reset();
    localStorage.removeItem('@TransfacilPJ:DepartmentFilter');
    setFilters({
      filters: [{ page }, { quantity: perPage }],
    });
  }, []);

  const funcionarioOptions = [
    { value: 'name', label: 'Funcionário' },
    { value: 'card', label: 'Cartão' },
    { value: 'register', label: 'Matrícula' },
    { value: 'cpf', label: 'CPF' },
  ];

  const handleNumberOrderFilter = useCallback(
    (data: any) => {
      const searchFor = data.funcionario;
      setFilters({
        filters: [
          ...filters.filters,
          searchFor === 'name'
            ? {
                name: data.search,
              }
            : searchFor === 'card'
            ? {
                card: data.search,
              }
            : searchFor === 'register'
            ? {
                register: data.search,
              }
            : searchFor === 'cpf'
            ? {
                cpf: data.search,
              }
            : {
                name: data.search,
              },
        ],
      });
    },
    [filters],
  );

  const openModalCSV = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
  }, []);

  const openModalPDF = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
  }, []);

  const getStatusText = useCallback((status: any) => {
    const statusOptions: any = {
      I: 'INATIVO',
      A: 'ATIVO',
    };
    return statusOptions[status];
  }, []);

  const getStatusTextModal = useCallback((status: any) => {
    const statusOptions: any = {
      I: 'Ativar',
      A: 'Inativar',
    };
    return statusOptions[status];
  }, []);

  const handleReport = useCallback(
    async (type: string) => {
      const localSt = localStorage.getItem('@TransfacilPJ:DepartmentFilter');
      if (localSt) {
        const convert = JSON.parse(localSt);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              'code-departament': localSt ? convert.name : '',
              status: statusRel || '',
            },
          ],
        };
        try {
          setLoadingModal(true);
          const response = await services.EmployeeService.getEmployeeReport(
            reportFilters,
            type,
          );
          DownLoadFile(response.data, `funcionários.${type}`);
          setLoadingModal(false);
        } catch (err: any) {
          setLoadingModal(false);
          const { ...error } = err;
          if (err.response.data) {
            if (err.response.status === 406) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  err.response.data.Summary.ErrorCollection
                    .SystemFailureErros[0].InternalErrorMessage,
              });
            }
            if (err.response.status === 500) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  'Servidor indisponível, tente novamente mais tarde',
              });
            }
          } else {
            addToast({
              type: 'error',
              title: 'Erro ao atualizar',
              description: 'Erro desconhecido ao atualizar',
            });
          }
          console.error(error);
        }
      } else {
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              status: statusRel || '',
            },
          ],
        };

        try {
          setLoadingModal(true);
          const response = await services.EmployeeService.getEmployeeReport(
            reportFilters,
            type,
          );
          DownLoadFile(response.data, `funcionários.${type}`);
          setLoadingModal(false);
        } catch (err: any) {
          setLoadingModal(false);
          const { ...error } = err;
          if (err.response.data) {
            if (err.response.status === 406) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  err.response.data.Summary.ErrorCollection
                    .SystemFailureErros[0].InternalErrorMessage,
              });
            }
            if (err.response.status === 500) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  'Servidor indisponível, tente novamente mais tarde',
              });
            }
          } else {
            addToast({
              type: 'error',
              title: 'Erro ao atualizar',
              description: 'Erro desconhecido ao atualizar',
            });
          }
          console.error(error);
        }
      }
    },
    [statusRel],
  );
  const RelatorioAgendados = useCallback(
    async (type: string) => {
      const localSt = localStorage.getItem('@TransfacilPJ:DepartmentFilter');
      if (localSt) {
        const convert = JSON.parse(localSt);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              'code-departament': localSt ? convert.name : '',
              status: statusRel || '',
            },
          ],
        };
        try {
          const response = await services.EmployeeService.getEmployeeReport(
            reportFilters,
            type,
          );
        } catch (err: any) {
          const { ...error } = err;
          if (err.response.data) {
            if (err.response.status === 406) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  err.response.data.Summary.ErrorCollection
                    .SystemFailureErros[0].InternalErrorMessage,
              });
            }
            if (err.response.status === 500) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  'Servidor indisponível, tente novamente mais tarde',
              });
            }
          } else {
            addToast({
              type: 'error',
              title: 'Erro ao atualizar',
              description: 'Erro desconhecido ao atualizar',
            });
          }
          console.error(error);
        }
      } else {
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              status: statusRel || '',
            },
          ],
        };

        try {
          const response = await services.EmployeeService.getEmployeeReport(
            reportFilters,
            type,
          );
        } catch (err: any) {
          const { ...error } = err;
          if (err.response.data) {
            if (err.response.status === 406) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  err.response.data.Summary.ErrorCollection
                    .SystemFailureErros[0].InternalErrorMessage,
              });
            }
            if (err.response.status === 500) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  'Servidor indisponível, tente novamente mais tarde',
              });
            }
          } else {
            addToast({
              type: 'error',
              title: 'Erro ao atualizar',
              description: 'Erro desconhecido ao atualizar',
            });
          }
          console.error(error);
        }
      }
    },
    [statusRel],
  );

  function relatorio() {
    push('/agendado');
  }

  const handleReportAsync = useCallback(
    async (type: string, Email: string) => {
      try {
        setLoadingModal(true);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              email: Email,
              user: titular.IdentificadorTitular,
              async: true,
            },
          ],
        };

        await services.EmployeeService.getEmployeeReport(
          reportFilters,
          type,
        );

        addToast({
          type: 'success',
          title:
            'Recebemos sua solicitação, em até 24 horas você receberá o arquivo solicitado por e-mail.',
        });

        setLoadingModal(false);
      } catch (err: any) {
        setLoadingModal(false);

        addToast({
          type: 'error',
          title: `${err.response.data.message} ${err.response.data.sub_message}`,
        });
        const { ...error } = err;
        console.error(error);
      }
    },
    [titular],
  );

  const handleSubmitAtivar = useCallback(
    async (data: any) => {
      try {
        formRefAtivar.current?.setErrors({});
        setLoading(true);
        console.log(statusCodigo);

        const responseEmployee = await services.EmployeeService.getEmployeeId(
          statusCodigo,
        );

        console.log(statusCodigo);
        console.log(data);

        if (responseEmployee.data.Funcionario.Status === 'A') {
          setStatusChecked(true);
        } else {
          setStatusChecked(false);
        }

        setEmployeesCPF(responseEmployee.data.Funcionario.FuncCpf);

        const StatusData = responseEmployee.data.Funcionario.Status === 'I' ? 'A' : 'I';
        // const changedCpf = data.FuncCpf.replace(/\D/g, '');

        const UpdateData = {
          CodigoFuncionario: statusCodigo,
          Status: StatusData,
        };
        console.log(UpdateData);

        await services.EmployeeService.updateEmployee(UpdateData);
        setModalAtivar(false);
        setLoading(false);
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Funcionário atualizado com sucesso!!',
        });
        await getEmployeesList();
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefAtivar.current?.setErrors(errors);
          return;
        }
        console.log(err);
        if (err.response.data) {
          if (err.response.status === 406) {
            addToast({
              type: 'error',
              title: 'Erro ao atualizar',
              description:
                err.response.data.Summary.ErrorCollection.SystemFailureErros[0]
                  .InternalErrorMessage,
            });
          }
          if (err.response.status === 500) {
            addToast({
              type: 'error',
              title: 'Erro ao atualizar',
              description: 'Servidor indisponível, tente novamente mais tarde',
            });
          }
        } else {
          addToast({
            type: 'error',
            title: 'Erro ao atualizar',
            description: 'Erro desconhecido ao atualizar',
          });
        }

        console.error(err);
      }
    },
    [addToast, statusCodigo],
  );

  const handleSubmitAssociar = useCallback(
    async (data: any) => {
      try {
        setLoading(true);
        await services.EmployeeService.linkCardManual(
          associarField.toString(),
          data.cardnumber,
        );
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Cartão associado com sucesso.',
        });
        setLoading(false);
        setModalAssociarTable(false);
        getEmployeesList();
      } catch (err: any) {
        if (err.response.data.Summary.ErrorCollection.DataValidationErros) {
          addToast({
            type: 'error',
            title: 'Erro ao associar',
            description:
              err.response.data.Summary.ErrorCollection.DataValidationErros[0]
                .InternalErrorMessage,
          });
        }
        setLoading(false);
        setModalAssociarTable(false);
      }
    },
    [associarField, addToast],
  );

  const handleSubmit = useCallback(async (data: any) => {
    try {
      formRefTxt.current?.setErrors({});

      await schema.validate(data, {
        abortEarly: false,
      });
      const formData = new FormData();

      for (const name in data) {
        if (Object.prototype.hasOwnProperty.call(data, name)) {
          formData.append(name, data[name]);
        }
      }
      setImportLoading(true);
      const response = await services.EmployeeService.importExmployee(formData);
      setImportLoading(false);

      if (response.data.ErrosImportacao !== null) {
        setErrors(response.data.Summary.ErrorCollection.DataValidationErros);
      } else if (
        response.data.Summary.ErrorCollection.DataValidationErros.length
      ) {
        setErrors(response.data.Summary.ErrorCollection.DataValidationErros);
      }
      if (response.data.Summary.Success) {
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Funcionário(s) importado(s) com sucesso',
        });
      }
      setModalImportarTxt(false);
      getEmployeesList();
    } catch (err: any) {
      const { ...error } = err;
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRefTxt.current?.setErrors(errors);
        return;
      }
      setImportLoading(false);
      setModalImportarTxt(true);

      if (typeof error.response.data !== 'string') {
        if (error.response.data.ErrosImportacao !== null) {
          setErrors(error.response.data.ErrosImportacao);
        }
        if (
          error.response.data.Summary.ErrorCollection.DataValidationErros[0]
        ) {
          addToast({
            type: 'error',
            title:
              error.response.data.Summary.ErrorCollection.DataValidationErros[0]
                .ErrorMessage,
            description:
              error.response.data.Summary.ErrorCollection.DataValidationErros[0]
                .InternalErrorMessage,
          });
        }
      } else {
        addToast({
          type: 'error',
          title: 'Erro interno do servidor',
        });
      }
    }
  }, []);

  const handleSubmitExcluir = useCallback(
    async (data: any) => {
      try {
        console.log({ data });
        setLoading(true);
        await services.EmployeeService.deleteEmployee(
          excluirCodigo,
        );
        await getEmployeesList();
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Funcionário excluído com sucesso',
        });
        setLoading(false);
        setModalExcluir(false);
      } catch (err: any) {
        const mensagem = `${err.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}. ${err.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`;
        addToast({
          type: 'error',
          title: 'Erro ao excluir',
          description: mensagem,
        });
        setLoading(false);
        setModalExcluir(false);
      }
    },
    [excluirCodigo, addToast],
  );

  const handleSubmitRelatorio = useCallback(
    async (data: any) => {
      try {
        formRefRelatorio.current?.setErrors({});
        await schemaRelatorio.validate(data, {
          abortEarly: false,
        });
        setLoading(true);
        await handleReportAsync(tipoRelatorio, data.email);
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefRelatorio.current?.setErrors(errors);
        }
        addToast({
          type: 'error',
          title:
            err.response.data.Summary.ErrorCollection.DataValidationErros[0]
              .ErrorMessage,
          description:
            err.response.data.Summary.ErrorCollection.DataValidationErros[0]
              .InternalErrorMessage,
        });
      }
    },
    [tipoRelatorio, titular],
  );

  const handleAutoCardLink = useCallback(async () => {
    try {
      await services.EmployeeService.autoCardLink({
        CodTipoUtiliz: 1,
      });
      addToast({
        type: 'success',
        title: 'Vinculação automatica Realizada com sucesso!!',
      });
    } catch (err: any) {
      const { ...error } = err;
      addToast({
        type: 'error',
        title:
          error.response.data.Summary.ErrorCollection.SystemFailureErros[0]
            .ErrorMessage,
      });
      console.error(error);
    }
  }, []);

  const importFile = useCallback(() => {
    window.open('/files/funcionarios.txt');
  }, []);
  const importFile2 = useCallback(() => {
    window.open('/files/funcionariocsv.txt');
  }, []);

  const GERARCSV = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
    RelatorioAgendados('csv');
  }, []);

  const GERARPDF = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
    RelatorioAgendados('pdf');
  }, []);

  return (
    <>
      {loading && <MainLoader />}
      <Container>
        <Row className="titleWrapper">
          <Column small="1" medium="1" large="1">
            <IconContainer align="center">
              <HiOutlineUserGroup size={125} />
            </IconContainer>
          </Column>
          <Column small="10" medium="10" large="10" className="TitleContainer">
            <div>
              <Title>Funcionários</Title>
              <ButtonsContainer>
                <div className="buttonsInitial">
                  <Link to="/funcionario/novo" className="btn">
                    ADICIONAR FUNCIONÁRIO
                  </Link>
                  {/* <Button
                    color="orange"
                    padding="1"
                    type="button"
                    className="associar"
                    onClick={() => setModalAssociar(true)}
                  >
                    <div className="icon">
                      <FiLink2 />
                    </div>
                    ASSOCIAR CARTÕES
                  </Button> */}
                  {titular?.SelectedClient && (
                    <Button
                      color="orange"
                      padding="1"
                      type="button"
                      className="importar"
                      onClick={() => setModalImportarTxt(true)}
                    >
                      IMPORTAR
                    </Button>
                  )}
                </div>
              </ButtonsContainer>
            </div>
          </Column>
        </Row>

        <FiltersContainer>
          <div className="filter">
            <Button
              color="aside-background"
              padding="1"
              textBlack
              type="button"
              className="pdf"
              onClick={() => setShowModal(true)}
            >
              <MdFilterList />
              FILTROS
            </Button>
          </div>

          <div className="search">
            <Form ref={formRef} onSubmit={handleNumberOrderFilter}>
              <Input
                id="search"
                name="search"
                type="text"
                placeholder="Buscar funcionário por..."
              >
                <Select
                  name="funcionario"
                  placeholder="Funcionário"
                  defaultValue={{
                    value: 'name',
                    label: 'Funcionário',
                  }}
                  className="select"
                  options={funcionarioOptions}
                />
              </Input>

              <Button
                color="orange"
                padding="1"
                type="submit"
                className="searchButton"
              >
                <MdSearch size={20} />
              </Button>
            </Form>
          </div>
          <div className="buttonsContainer">
            <Button
              color="purple"
              padding="1"
              type="button"
              className="clearFilters"
              onClick={handleClearFilters}
            >
              <div className="icon">
                <MdFilterList />
              </div>
              LIMPAR FILTROS
            </Button>
            <Button
              color="purple"
              padding="1"
              type="button"
              className="csv"
              onClick={() => {
                if (titular.AsyncReport === true) {
                  GERARCSV();
                } else {
                handleReport('csv');
                }
              }}
            >
              <div className="icon">
                <HiDownload />
              </div>
              GERAR CSV
            </Button>
            <Button
              color="purple"
              padding="1"
              type="button"
              className="pdf"
              onClick={() => {
                if (titular.AsyncReport === true) {
                  GERARPDF();
                } else {
                handleReport('pdf');
                }
              }}
            >
              <div className="icon">
                <HiDownload />
              </div>
              GERAR PDF
            </Button>
          </div>
        </FiltersContainer>
        <CardOrdersTable
          data={employees.FuncionarioLista}
          columns={[
            {
              name: 'Funcionário',
              selector: 'Nome',
              cell: ({ Nome, CodigoDoFuncionario }: any) => (
                <Link
                  to={`/funcionarios/${CodigoDoFuncionario}`}
                  style={{
                    textDecoration: 'underline',
                    textUnderlinePosition: 'under',
                  }}
                >
                  {Nome}
                </Link>
              ),
            },
            {
              name: 'Matrícula',
              selector: 'Matricula',
            },
            {
              name: 'Status',
              selector: 'Status',
              center: true,
              cell: ({ Status }: any) => (
                <StatusRow status={Status}>{getStatusText(Status)}</StatusRow>
              ),
            },
            {
              name: 'Cartão',
              selector: 'CodigoDoFuncionario',
              cell: ({ CodigoDoFuncionario, CrtCodIdentifExt }: any) => (
                <>
                  {CrtCodIdentifExt ? (
                    <div>{CrtCodIdentifExt}</div>
                  ) : (
                    <CardSection
                      onClick={() => {
                        setModalAssociarTable(true);
                        setAssociarField(CodigoDoFuncionario);
                      }}
                    >
                      ASSOCIAR CARTÃO
                    </CardSection>
                  )}
                </>
              ),
            },
            {
              name: 'Ações',
              selector: 'CodigoDoFuncionario',
              cell: ({ CodigoDoFuncionario, Nome, Status, FuncCpf, Matricula }: any) => (
                <Acoes>
                  <div className="clickable" title="Editar">
                    <Link to={`/funcionarios/${CodigoDoFuncionario}/editar`}>
                      <EditIcon style={{ color: '#EB5E35' }} />
                    </Link>
                  </div>
                  <div
                    className="clickable"
                    title="Deletar"
                    role="button"
                    onClick={() => {
                      setModalExcluir(true);
                      setExcluirCodigo(CodigoDoFuncionario.toString());
                      setExcluirNome(Nome);
                    }}
                    onKeyDown={() => {
                      setModalExcluir(true);
                      setExcluirCodigo(CodigoDoFuncionario.toString());
                      setExcluirNome(Nome);
                    }}
                    tabIndex={-1}
                  >
                    <DeleteIcon style={{ color: '#EB5E35' }} />
                  </div>
                  <div className="clickable">
                    <button
                      type="button"
                      className="clickable"
                      onClick={() => {
                        setModalAtivar(true);
                        setFuncionarioCPF(FuncCpf);
                        setStatusCodigo(CodigoDoFuncionario.toString());
                        setStatusNome(getStatusTextModal(Status));
                        setAtivarNome(Nome);
                        setAtivarMatricula(Matricula);
                      }}
                    >
                      {Status === 'A' && (
                        <ImCheckboxChecked
                          title={getStatusTextModal(Status)}
                          style={{ color: '#EB5E35' }}
                        />
                      )}
                      {Status === 'I' && (
                        <ImCheckboxUnchecked
                          title={getStatusTextModal(Status)}
                          style={{ color: '#EB5E35' }}
                        />
                      )}
                    </button>
                  </div>
                </Acoes>
              ),
            },
          ]}
          loading={loading}
          totalRows={totalRows}
          onChangePage={handleChangePerPage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          emptyText="Nenhum Funcionário"
        />
        {showModal && (
          <FiltersModal
            handleClose={() => setShowModal(false)}
            filters={filters}
            departamentos={departamentos}
            handleApplyFilter={handleApplyFilter}
            show={showModal}
            title="Filtros"
          />
        )}
        {modalAssociar && (
          <Modal
            handleClose={() => setModalAssociar(false)}
            show={modalAssociar}
            title="Associação automática"
          >
            A associação de cartões disponíveis com funcionários será feita de
            forma automática.
            <FlexRow>
              <Button
                type="button"
                padding="6"
                color="orange"
                className="btn"
                role="button"
                onClick={() => setModalAssociar(false)}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                padding="6"
                color="orange"
                onClick={() => handleAutoCardLink()}
              >
                Confirmar
              </Button>
            </FlexRow>
          </Modal>
        )}
        {modalImportar && (
          <Modal
            handleClose={() => setModalImportar(false)}
            show={modalImportar}
            title="Importação em massa"
          >
            <FlexRow>
              <AiOutlineFile size="100" />
            </FlexRow>
            <p>
              Escolha um arquivo para importar seus funcionários em massa. Mas
              atenção, os campos Nome, CPF, Matrícula e Cartão BHBUS (para
              cadastros existentes) são obrigatórios. Não deixe de conferir o
              &nbsp;
              <LinkModal href="https://empresa.bhbus.com.br/assets/files/funcionarios.txt">
                arquivo de exemplo.
              </LinkModal>
            </p>
            <FlexRow>
              <Button
                type="button"
                padding="6"
                color="orange"
                className="btn"
                role="button"
                onClick={() => setModalImportar(false)}
              >
                Cancelar
              </Button>
              <Button type="button" padding="6" color="orange">
                Escolher arquivo
              </Button>
            </FlexRow>
          </Modal>
        )}
        {modalAssociarTable && (
          <Modal
            handleClose={() => setModalAssociarTable(false)}
            show={modalAssociarTable}
            title="Associação manual"
          >
            Digite o número do cartão que deseja associar.
            <FormWrapper>
              <Form ref={formRefAssociar} onSubmit={handleSubmitAssociar}>
                <Input
                  id="cardnumber"
                  name="cardnumber"
                  type="text"
                  cardtransfacildigito
                  label="Número do cartão"
                />

                <FlexRow>
                  <div className="btn-wrapper">
                    <Button
                      type="button"
                      padding="1"
                      color="orange"
                      className="btn"
                      role="button"
                      onClick={() => setModalAssociarTable(false)}
                    >
                      Cancelar
                    </Button>
                    <Button type="submit" padding="1" color="orange">
                      Confirmar
                    </Button>
                  </div>
                </FlexRow>
              </Form>
            </FormWrapper>
          </Modal>
        )}

        {modalExcluir && (
          <Modal
            handleClose={() => setModalExcluir(false)}
            show={modalExcluir}
            title="Remoção de funcionário"
          >
            Tem certeza de que deseja remover &nbsp;
            {excluirNome}?
            <FlexRow>
              <div className="btn-wrapper">
                <Form ref={formRefExcluir} onSubmit={handleSubmitExcluir}>
                  <Button
                    type="button"
                    padding="6"
                    color="orange"
                    className="btn"
                    role="button"
                    onClick={() => setModalExcluir(false)}
                  >
                    Não
                  </Button>
                  <Button
                    type="submit"
                    padding="4"
                    color="orange"
                    className="btn-remover"
                  >
                    Sim, remover
                  </Button>
                </Form>
              </div>
            </FlexRow>
          </Modal>
        )}

        {modalAtivar && (
          <Modal
            handleClose={() => setModalAtivar(false)}
            show={modalAtivar}
            title={`${statusNome} funcionário`}
          >
            Tem certeza de que deseja {statusNome} o funcionário &nbsp;
            {ativarNome}?
            <FlexRow>
              <div className="btn-wrapper">
                <Form ref={formRefAtivar} onSubmit={handleSubmitAtivar}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    className="DadosFunc"
                  >
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <h3>Nome: </h3>
                      <h4>{ativarNome}</h4>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <h3>Matrícula:</h3>
                      <h4>{ativarMatricula}</h4>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <h3>Status Atual:</h3>
                      <h4>{statusNome === "Inativar" ? "Ativo" : "Inativo"}</h4>
                    </div>
                  </div>
                  <div className="checkbox">
                    <Checkbox
                      name="Status"
                      checked={statusChecked}
                      onClick={() => setStatusChecked(!statusChecked)}
                      options={[
                        {
                          id: 'ativo',
                          value: 'A',
                          label: 'Ativo',
                        },
                      ]}
                    />
                  </div>
                  <Button
                    type="button"
                    padding="6"
                    color="orange"
                    className="btn btn-modal"
                    role="button"
                    onClick={() => setModalAtivar(false)}
                  >
                    Não
                  </Button>
                  <Button
                    type="submit"
                    padding="5"
                    color="orange"
                    className="btn-remover"
                    onClick={() => setStatusChecked(!statusChecked)}
                  >
                    Sim, {statusNome}
                  </Button>
                </Form>
              </div>
            </FlexRow>
          </Modal>
        )}

        {modalImportarTxt && (
          <>
            <Modal
              handleClose={() => setModalImportarTxt(false)}
              show={modalImportarTxt}
              title="Importação em massa"
            >
              {importLoading ? (
                <TableLoader />
              ) : (
                <Form
                  ref={formRefTxt}
                  onSubmit={handleSubmit}
                  className="importForm"
                >
                  {errors.length > 0 && (
                    <div className="erro">
                      <div className="errosLength">{`Houve ${errors.length} erro de importação:`}</div>
                      {errors.map((erro: any) => (
                        <>
                          <div className="descriptionErro" key={erro}>
                            {!!erro.InternalErrorMessage &&
                              erro.InternalErrorMessage}
                            {typeof erro === 'string' && erro}
                          </div>
                        </>
                      ))}
                    </div>
                  )}
                  <p>
                    Escolha um arquivo com extensão txt ou csv para importar seus funcionários em massa.
                  </p>
                  <p>
                    Mas atenção, os campos &nbsp;
                    <b>Nome, Matrícula e Cartão BHBUS </b>
                    (para cadastros existentes) são obrigatórios.
                  </p>
                  <p>
                    Não deixe de conferir o &nbsp;
                    <a
                      href="/files/exemploFuncionario.txt"
                      target="_blank"
                      className="link"
                      download="exemploFuncionario"
                      rel="noreferrer"
                      onClick={importFile}
                    >
                      arquivo de exemplo txt.
                    </a>
                  </p>

                  <p>
                    Ou então o &nbsp;
                    <a
                      href="/files/exemplofuncionariocsv.csv"
                      target="_blank"
                      className="link"
                      download="exemplofuncionariocsv.csv"
                      rel="noreferrer"
                      onClick={importFile2}
                    >
                      arquivo de exemplo csv.
                    </a>
                  </p>

                  <span />
                  <div className="file-picker">
                    <FileInput
                      name="ArquivoImportacao"
                      title="Escolher arquivo"
                    />
                  </div>
                  <FlexRow>
                    <div className="btn-wrapper">
                      <Button
                        type="button"
                        color="orange"
                        padding="3"
                        className="btn-cancelar"
                        onClick={() => setModalImportarTxt(false)}
                      >
                        CANCELAR
                      </Button>
                      <Button
                        type="submit"
                        color="orange"
                        padding="3"
                        className="btn-enviar"
                      >
                        ENVIAR
                      </Button>
                    </div>
                  </FlexRow>
                </Form>
              )}
            </Modal>
          </>
        )}
        {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
        {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <Form ref={formRefRelatorio} onSubmit={handleSubmitRelatorio}>
              <FormWrapper>
                <p>Estamos processando os dados do pedido do Relatório.</p>
                <p>
                  <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                  Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                  solicitado. Quando este processo for finalizado basta fazer o
                  download do arquivo.
                </p>
              </FormWrapper>
            </Form>
          </ModalContent>
        </Modal>
      )}

      </Container>
    </>
  );
};

export default Funcionarios;
